import { Action, defaultActions } from '#/common/components/DataGrid';
import { Expense } from '#/graphql/types';

export const actions: Action<Expense>[] = [...defaultActions];
